import React from 'react';
import { FolderItemORM } from 'src/types/types'
import { useAttendeeShareScreen, useMeetingControls } from '@alucio/video';
import {
  SelectedRightSideBarComponentEnum,
} from '@alucio/video/lib/src/packages/video/src/hooks/useMeetingControls/useMeetingControl';
import { useContentViewerModalState } from 'src/components/ContentPreviewModal/state/ContentViewerModalStateProvider';
import useMyContentPanelSharedResources, { MyContentPanelProps } from '../useMyContentPanelSharedResources';

import { Animated } from 'react-native';
import { DNABox, DNADivider, Iffy } from '@alucio/lux-ui';
import Content from '../Content';
import Header from '../Header';
import { DNAModalActions } from 'src/state/redux/slice/DNAModal/DNAModal';
import { useDispatch } from 'react-redux';
import DNACommonConfirmation from 'src/components/DNA/Modal/DNACommonConfirmation';

function VirtualVariant(props: MyContentPanelProps) {
  const {
    setActiveDocVersionAndSlide,
    setActiveFolderItemAndSlide,
    loadedDocuments,
    documentTabLimit,
  } = useContentViewerModalState();
  const {
    selectedDocumentVersion,
    togglePanelView,

    bottom,
    mainWrapperVisibilityStyle,
    selectedTab,
    localSearchText,
    setSelectedTabHandler,
    displayMode,
    setLocalSearchText,
    setSearchText,
    searchText,
    setSelectedDocumentVersion,
    styles,

  } = useMyContentPanelSharedResources(props)
  const { sendStopAllShareScreen } = useAttendeeShareScreen();
  const { selectTabOption, setRightSideBarVisible } = useMeetingControls();
  const dispatch = useDispatch()

  function onPresent(page: number, folderItemORM?: FolderItemORM): void {
    if (loadedDocuments.length === documentTabLimit ) {
      dispatch(DNAModalActions.setModal({
        isVisible: true,
        allowBackdropCancel: true,
        component: () => (
          <DNACommonConfirmation
            title="Tab limit"
            descriptionText="You can have up to 10 tabs open."
            cancelText="Close"
            status="brand"
          />
        ),
      }),
      )
      return
    }
    sendStopAllShareScreen();
    togglePanelView(false);
    selectTabOption(SelectedRightSideBarComponentEnum.NOTES);
    setRightSideBarVisible(true);

    if (folderItemORM) {
      setActiveFolderItemAndSlide(folderItemORM, page);
    } else if (selectedDocumentVersion) {
      setActiveDocVersionAndSlide(selectedDocumentVersion, page);
    }
  }

  return (
    <Animated.View
      style={[
        styles.mainWrapper,
        { transform: [{ translateY: bottom }] },
        mainWrapperVisibilityStyle,
      ]}
    >
      <DNABox appearance="col" fill style={styles.content}>
        <Header
          selectedTab={selectedTab}
          localSearchText={localSearchText}
          onClosePanel={() => togglePanelView(false)}
          selectedDocument={selectedDocumentVersion?.relations.document}
          onSelectTab={setSelectedTabHandler}
          displayMode={displayMode}
          setLocalSearchText={setLocalSearchText}
          setSearchText={setSearchText}
          sessionId={props.sessionId}
        />
        <DNADivider variant="virtual" />
        <Iffy is={selectedTab} >
          <Content
            localSearchText={localSearchText}
            searchText={searchText}
            selectedTab={selectedTab}
            selectedDocumentVersion={selectedDocumentVersion}
            setSelectedDocumentVersion={setSelectedDocumentVersion}
            setSelectedPage={onPresent}
            displayMode={displayMode}
            sessionId={props.sessionId}
          />
        </Iffy>
      </DNABox>
    </Animated.View>
  );
}

export default VirtualVariant;
